import PropTypes from "prop-types";
import { useState } from "react";

import styled from "styled-components/macro";

import { useGetAlertData } from "Giving/ManageMyGivingPage/API/queries";
import { alertTypeToId, alertTypes } from "Giving/constants";
import { AnimatePresence } from "framer-motion";

import Alert from "./Alert";
import UpdateACHModal from "./UpdateACHModal";
import UpdateCCModal from "./UpdateCCModal";
import useDismissibleAlerts from "./useDismissibleAlerts";

const determineAlertType = (alert) => {
  let alertType = "";
  switch (alert.givingAlertTypeID) {
    case alertTypeToId[alertTypes.WEPAY_CC_ALERT]:
      alertType = alertTypes.WEPAY_CC_ALERT;
      break;
    case alertTypeToId[alertTypes.WEPAY_ACH_ALERT]:
      alertType = alertTypes.WEPAY_ACH_ALERT;
      break;
    case alertTypeToId[alertTypes.PLEDGE_PAYMENT_ALERT]:
      alertType = alertTypes.PLEDGE_PAYMENT_ALERT;
      break;
    case alertTypeToId[alertTypes.PLEDGE_BEHIND_ALERT]:
      alertType = alertTypes.PLEDGE_BEHIND_ALERT;
      break;
    default:
      alertType = alertTypes.WEPAY_ACH_ALERT;
      break;
  }
  return alertType;
};

export default function Alerts() {
  const { data } = useGetAlertData();

  const { alerts, dismissAlert } = useDismissibleAlerts(
    data?.givingAlerts || []
  );

  const [activeAlertID, setActiveAlertID] = useState();

  return (
    <Wrapper>
      <AnimatePresence>
        {alerts?.map((alert, index) => {
          if (alert.dismissed) return null;
          return (
            <Alert
              key={alert.ID}
              alert={alert}
              data-cy={`alert-${index}`}
              dismissAlert={dismissAlert}
              alertType={determineAlertType(alert)}
              index={index}
              setActiveAlertID={() => setActiveAlertID(alert.ID)}
            />
          );
        })}
      </AnimatePresence>

      <UpdateACHModal alerts={alerts} activeAlertID={activeAlertID} />
      <UpdateCCModal alerts={alerts} activeAlertID={activeAlertID} />
    </Wrapper>
  );
}

Alerts.propTypes = {
  initialAlerts: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
      givingAlertTypeID: PropTypes.number,
      icon: PropTypes.string,
      givingAlertStatusID: PropTypes.number,
      isDismissible: PropTypes.bool,
    })
  ),
};
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;
